import { Box, Button } from "@mui/material";

import { useState } from "react";
import { ExchangeMapperDialog } from "./ExchangeMapperDialog";
import { ExchangeMapperTable } from "./ExchangeMapperTable";

export const ExchangeMapper = () => {
  const [isCreationOpen, setIsCreationOpen] = useState(false);
  return (
    <Box>
      <Box display="flex" justifyContent="flex-end" paddingBottom={2}>
        <Button
          onClick={() => setIsCreationOpen(true)}
          variant="contained"
          color="primary"
        >
          Assign
        </Button>
      </Box>
      <ExchangeMapperTable />
      <ExchangeMapperDialog
        open={isCreationOpen}
        onClose={() => setIsCreationOpen(false)}
      />
    </Box>
  );
};
